import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from '../entity';

@JsonObject('columns')
export class DataColumn extends Entity {
  @JsonProperty('name', String)
  public name?: string = undefined;
  @JsonProperty('type', String)
  public type?: string = undefined;
  @JsonProperty('sortable', Boolean)
  public sortable?: boolean = undefined;
}